import type { TkDict } from "./types";

const dict: TkDict = {
  uz: {
    "tk.dashboard.copy": "Nusxa",
    "tk.dashboard.status.unpaid": "To'lanmagan",
    "tk.dashboard.until": "Tantanagacha",
    "tk.dashboard.days.one": "{n} kun",
    "tk.dashboard.days.few": "{n} kun",
    "tk.dashboard.days.many": "{n} kun",
    "tk.dashboard.days.other": "{n} kun",
    "tk.dashboard.date.full": "{d}-{m}, {y}",
    "tk.dashboard.date.short": "{d}-{m}",
    "tk.dashboard.today": "Bugun",
    "tk.dashboard.yesterday": "Kecha",
    "tk.dashboard.month.1": "yanvar",
    "tk.dashboard.month.2": "fevral",
    "tk.dashboard.month.3": "mart",
    "tk.dashboard.month.4": "aprel",
    "tk.dashboard.month.5": "may",
    "tk.dashboard.month.6": "iyun",
    "tk.dashboard.month.7": "iyul",
    "tk.dashboard.month.8": "avgust",
    "tk.dashboard.month.9": "sentabr",
    "tk.dashboard.month.10": "oktabr",
    "tk.dashboard.month.11": "noyabr",
    "tk.dashboard.month.12": "dekabr",
    "tk.dashboard.crumbs": "Sahifa yo'li",
    "tk.dashboard.link.edit": "Havolani o'zgartirish",
    "tk.dashboard.sections": "Bo'lim",
    "tk.dashboard.stat.yes": "Keladi",
    "tk.dashboard.stat.no": "Kelmaydi",
    "tk.dashboard.stat.total": "Jami javoblar",
    "tk.dashboard.stat.share": "javoblarning {n}%",
    "tk.dashboard.stat.maybe": "Balki: {n}",
    "tk.dashboard.stat.capped": "Oxirgi {n} ta mehmon bo'yicha",
    "tk.dashboard.stat.wishes_sub": "mehmonlardan",
    "tk.dashboard.rsvp.yes": "Keladi",
    "tk.dashboard.rsvp.no": "Kelmaydi",
    "tk.dashboard.rsvp.maybe": "Balki",
    "tk.dashboard.responses": "Javoblar",
    "tk.dashboard.responses.filter": "Javob turi",
    "tk.dashboard.responses.guest": "Mehmon",
    "tk.dashboard.responses.answer": "Javob",
    "tk.dashboard.responses.empty": "Hozircha javoblar yo'q. Havolani ulashing — mehmonlar javobi shu yerda paydo bo'ladi.",
    "tk.dashboard.responses.none": "Bu bo'limda hozircha javob yo'q.",
    "tk.dashboard.responses.shown": "{total} ta javobdan {n} tasi",
    "tk.dashboard.responses.less": "Qisqartirish",
    "tk.dashboard.wishes.manage": "Boshqarish",
    "tk.dashboard.wishes.empty": "Hozircha tilaklar yo'q — taklifnomangiz ulashilgach, mehmonlar yozadi.",
    "tk.dashboard.preview.title": "Mehmon ko'rinishi",
    "tk.dashboard.preview.body": "Taklifnoma mehmonlarga shunday ko'rinadi.",
  },
  ru: {
    "tk.dashboard.copy": "Копировать",
    "tk.dashboard.status.unpaid": "Не оплачено",
    "tk.dashboard.until": "До торжества",
    "tk.dashboard.days.one": "{n} день",
    "tk.dashboard.days.few": "{n} дня",
    "tk.dashboard.days.many": "{n} дней",
    "tk.dashboard.days.other": "{n} дня",
    "tk.dashboard.date.full": "{d} {m} {y}",
    "tk.dashboard.date.short": "{d} {m}",
    "tk.dashboard.today": "Сегодня",
    "tk.dashboard.yesterday": "Вчера",
    "tk.dashboard.month.1": "января",
    "tk.dashboard.month.2": "февраля",
    "tk.dashboard.month.3": "марта",
    "tk.dashboard.month.4": "апреля",
    "tk.dashboard.month.5": "мая",
    "tk.dashboard.month.6": "июня",
    "tk.dashboard.month.7": "июля",
    "tk.dashboard.month.8": "августа",
    "tk.dashboard.month.9": "сентября",
    "tk.dashboard.month.10": "октября",
    "tk.dashboard.month.11": "ноября",
    "tk.dashboard.month.12": "декабря",
    "tk.dashboard.crumbs": "Навигационная цепочка",
    "tk.dashboard.link.edit": "Изменить ссылку",
    "tk.dashboard.sections": "Раздел",
    "tk.dashboard.stat.yes": "Придут",
    "tk.dashboard.stat.no": "Не придут",
    "tk.dashboard.stat.total": "Всего ответов",
    "tk.dashboard.stat.share": "{n}% ответов",
    "tk.dashboard.stat.maybe": "Возможно: {n}",
    "tk.dashboard.stat.capped": "По последним {n} гостям",
    "tk.dashboard.stat.wishes_sub": "от гостей",
    "tk.dashboard.rsvp.yes": "Придёт",
    "tk.dashboard.rsvp.no": "Не придёт",
    "tk.dashboard.rsvp.maybe": "Возможно",
    "tk.dashboard.responses": "Ответы",
    "tk.dashboard.responses.filter": "Тип ответа",
    "tk.dashboard.responses.guest": "Гость",
    "tk.dashboard.responses.answer": "Ответ",
    "tk.dashboard.responses.empty": "Ответов пока нет. Поделитесь ссылкой — ответы гостей появятся здесь.",
    "tk.dashboard.responses.none": "В этом разделе пока нет ответов.",
    "tk.dashboard.responses.shown": "Показано {n} из {total}",
    "tk.dashboard.responses.less": "Свернуть",
    "tk.dashboard.wishes.manage": "Управлять",
    "tk.dashboard.wishes.empty": "Пожеланий пока нет — гости напишут, когда вы поделитесь приглашением.",
    "tk.dashboard.preview.title": "Глазами гостя",
    "tk.dashboard.preview.body": "Так приглашение видят ваши гости.",
  },
  en: {
    "tk.dashboard.copy": "Copy",
    "tk.dashboard.status.unpaid": "Unpaid",
    "tk.dashboard.until": "Celebration in",
    "tk.dashboard.days.one": "{n} day",
    "tk.dashboard.days.few": "{n} days",
    "tk.dashboard.days.many": "{n} days",
    "tk.dashboard.days.other": "{n} days",
    "tk.dashboard.date.full": "{m} {d}, {y}",
    "tk.dashboard.date.short": "{m} {d}",
    "tk.dashboard.today": "Today",
    "tk.dashboard.yesterday": "Yesterday",
    "tk.dashboard.month.1": "January",
    "tk.dashboard.month.2": "February",
    "tk.dashboard.month.3": "March",
    "tk.dashboard.month.4": "April",
    "tk.dashboard.month.5": "May",
    "tk.dashboard.month.6": "June",
    "tk.dashboard.month.7": "July",
    "tk.dashboard.month.8": "August",
    "tk.dashboard.month.9": "September",
    "tk.dashboard.month.10": "October",
    "tk.dashboard.month.11": "November",
    "tk.dashboard.month.12": "December",
    "tk.dashboard.crumbs": "Breadcrumb",
    "tk.dashboard.link.edit": "Change link",
    "tk.dashboard.sections": "Section",
    "tk.dashboard.stat.yes": "Attending",
    "tk.dashboard.stat.no": "Not attending",
    "tk.dashboard.stat.total": "Total responses",
    "tk.dashboard.stat.share": "{n}% of responses",
    "tk.dashboard.stat.maybe": "Maybe: {n}",
    "tk.dashboard.stat.capped": "Based on the latest {n} guests",
    "tk.dashboard.stat.wishes_sub": "from guests",
    "tk.dashboard.rsvp.yes": "Attending",
    "tk.dashboard.rsvp.no": "Not attending",
    "tk.dashboard.rsvp.maybe": "Maybe",
    "tk.dashboard.responses": "Responses",
    "tk.dashboard.responses.filter": "Response type",
    "tk.dashboard.responses.guest": "Guest",
    "tk.dashboard.responses.answer": "Response",
    "tk.dashboard.responses.empty": "No responses yet. Share your link — guests' replies will appear here.",
    "tk.dashboard.responses.none": "No responses in this group yet.",
    "tk.dashboard.responses.shown": "Showing {n} of {total}",
    "tk.dashboard.responses.less": "Show less",
    "tk.dashboard.wishes.manage": "Manage",
    "tk.dashboard.wishes.empty": "No wishes yet — guests will write once you share your invitation.",
    "tk.dashboard.preview.title": "Guest view",
    "tk.dashboard.preview.body": "This is how guests see your invitation.",
  },
};

export default dict;
